import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { API } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = chargement, false = non connecté
  const [tenant, setTenant] = useState(undefined); // undefined = chargement, null = aucun
  const [role, setRole] = useState(null);

  const loadTenant = useCallback(async () => {
    try {
      const { data } = await API.get("/tenant");
      setTenant(data.tenant);
      setRole(data.role);
    } catch {
      setTenant(null);
      setRole(null);
    }
  }, []);

  useEffect(() => {
    API.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  useEffect(() => {
    if (user) {
      setTenant(undefined);
      loadTenant();
    } else if (user === false) {
      setTenant(null);
      setRole(null);
    }
  }, [user, loadTenant]);

  const login = async (email, password) => {
    const { data } = await API.post("/auth/login", { email, password });
    setUser(data);
    return data;
  };

  const register = async (name, email, password) => {
    const { data } = await API.post("/auth/register", { name, email, password });
    setUser(data);
    return data;
  };

  const logout = async () => {
    await API.post("/auth/logout").catch(() => {});
    setUser(false);
    setTenant(null);
    setRole(null);
  };

  return (
    <AuthContext.Provider value={{ user, tenant, role, login, register, logout, reloadTenant: loadTenant }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
